import {
	BaseTextFieldProps,
	InputAdornment,
	MenuItem,
	Select,
	TextField,
	Typography,
} from '@mui/material';
import React from 'react';
import {
	CountryIso2,
	defaultCountries,
	FlagImage,
	parseCountry,
	usePhoneInput,
} from 'react-international-phone';
import 'react-international-phone/style.css';
import './PhoneInput.css';

export interface MUIPhoneProps extends BaseTextFieldProps {
	value: string;
	onChange: (phone: string) => void;
	name: string;
	placeholder?: string;
	required?: boolean;
}

export const MuiPhone: React.FC<MUIPhoneProps> = ({
	value,
	placeholder,
	onChange,
	required,
	...restProps
}) => {
	const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } = usePhoneInput({
		defaultCountry: 'ge',
		value,
		countries: defaultCountries,
		onChange: (data) => {
			onChange(data.phone);
		},
	});

	return (
		<TextField
			variant="outlined"
			classes={{ root: 'phoneInputRoot' }}
			placeholder={`${placeholder}${required ? ' *' : ''}`}
			sx={{
				borderRadius: '8px',
				'& .MuiInputBase-input': {
					color: restProps.error ? '#FD3333' : '#7B809A',
				},
				'& .MuiInputBase-input::placeholder': {
					color: '#7B809A',
					fontFamily: 'Roboto',
					fontSize: '14px',
					fontStyle: 'normal',
					fontWeight: 400,
					lineHeight: 'normal',
					opacity: 1,
				},
				'& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
					borderWidth: '2px',
					borderColor: '#FD3333',
				},
			}}
			value={inputValue}
			onChange={handlePhoneValueChange}
			type="tel"
			inputRef={inputRef}
			className="!text-secondary"
			InputProps={{
				classes: {
					input: 'phoneInputInput',
					notchedOutline: 'phoneInputNotchedOutline',
					root: 'phoneInputRoot',
				},
				startAdornment: (
					<InputAdornment position="start" style={{ marginRight: '2px', marginLeft: '-8px' }}>
						<Select
							MenuProps={{
								style: {
									height: '300px',
									width: '360px',
									top: '10px',
									left: '-34px',
								},
								transformOrigin: {
									vertical: 'top',
									horizontal: 'left',
								},
							}}
							sx={{
								width: 'max-content',
								fieldset: {
									display: 'none',
									border: 'none',
								},
								'&.Mui-focused:has(div[aria-expanded="false"])': {
									fieldset: {
										display: 'block',
										border: 'none',
									},
								},
								'.MuiSelect-select': {
									padding: '8px',
									paddingRight: '24px !important',
								},
								svg: {
									right: 0,
								},
							}}
							value={country.iso2}
							onChange={(e) => setCountry(e.target.value as CountryIso2)}
							renderValue={(value) => <FlagImage iso2={value} style={{ display: 'flex' }} />}
						>
							{defaultCountries.map((c) => {
								const country = parseCountry(c);

								return (
									<MenuItem key={country.iso2} value={country.iso2}>
										<FlagImage iso2={country.iso2} style={{ marginRight: '8px' }} />
										<Typography marginRight="8px">{country.name}</Typography>
										<Typography color="gray">+{country.dialCode}</Typography>
									</MenuItem>
								);
							})}
						</Select>
					</InputAdornment>
				),
			}}
			{...restProps}
		/>
	);
};
